import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Column} from "simple-flexbox";
import categoryService from "../../services/category";
import Utility from "../../utility";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`
const StatusBox = styled.div`
  padding: 20px;
  margin: 35px;
  height: 180px;
  width: 240px;
  background-color: #832729;
  display: flex;
  color: white;
  justify-content: space-evenly;
  align-items: flex-start;
  flex-direction: column;
  font-size: 22px;
`
const CountSpan = styled.span`
  font-size: 50px;
`
const SubHeadings = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 20px;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  align-items: center;
`

const HomeComponent = (props) => {
    const [homeState, setStateData] = useState();

    useEffect(() => {
        Utility.parseResponse(categoryService.getHomeAPIData()).then(([err, res]) => {
            if (err || !res) {
                return Utility.apiFailureToast('Server Error!')
            }
            setStateData(res)
        });
    }, [])

    return (
        <Column>
            <SubHeadings>My Gold Work</SubHeadings>
            {homeState && <Container>
                <StatusBox>
                    <CountSpan>{homeState?.pendingOrders}</CountSpan>
                    Pending Orders
                </StatusBox>
                <StatusBox>
                    <CountSpan>{homeState?.inProgressOrders}</CountSpan>
                    Orders In Progress
                </StatusBox>
                <StatusBox>
                    <CountSpan>{homeState?.successfulOrders}</CountSpan>
                    Successful Orders
                </StatusBox>
                <StatusBox>
                    <CountSpan>{homeState?.cancelledOrders}</CountSpan>
                    Cancelled Orders
                </StatusBox>
                <StatusBox>
                    <CountSpan>{homeState?.totalOrders}</CountSpan>
                    Total Orders
                </StatusBox>
                <StatusBox>
                    <CountSpan>{homeState?.products}</CountSpan>
                    Total Products
                </StatusBox>
                <StatusBox>
                    <CountSpan>{homeState?.categories}</CountSpan>
                    Total Categories
                </StatusBox>
                <StatusBox>
                    <CountSpan>{homeState?.users}</CountSpan>
                    Total Users
                </StatusBox>
            </Container>}
        </Column>
    );
}

export default HomeComponent;
